module.exports = __webpack_public_path__ + "img/moneyorder.1dde92c0.png";